import React from 'react';
import { 
  LuCalendar, 
  LuSlidersHorizontal, 
  LuDownload, 
  LuServer, 
  LuWrench, 
  LuCalendarDays, 
  LuFileText 
} from 'react-icons/lu';

import { FiCheckCircle, FiXCircle } from 'react-icons/fi';

export default function ComplianceOverview() {
  // Mock data representing the dashboard states
  const stats = [
    {
      id: 1,
      title: 'Total Equipment',
      value: '62',
      subtext: 'All locations',
      icon: LuServer,
      iconColor: 'text-indigo-600',
      bgColor: 'bg-indigo-50',
    },
    {
      id: 2,
      title: 'In Service',
      value: '54',
      subtext: 'Ready to use',
      icon: FiCheckCircle, // <--- CHANGED FROM LuCheckCircle TO FiCheckCircle
      iconColor: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
    },
    {
      id: 3,
      title: 'Maintenance Due',
      value: '5',
      subtext: 'Scheduled',
      icon: LuWrench,
      iconColor: 'text-orange-600',
      bgColor: 'bg-orange-50',
    },
    {
      id: 4,
      title: 'Out of Service',
      value: '2',
      subtext: 'Not in use',
      icon: FiXCircle, // <--- CHANGED FROM LuXCircle TO FiXCircle
      iconColor: 'text-rose-600',
      bgColor: 'bg-rose-50',
    },
    {
      id: 5,
      title: 'Next Maintenance Due',
      value: '22 Jul 2026',
      subtext: '4 days remaining',
      icon: LuCalendarDays,
      iconColor: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      id: 6,
      title: 'Key Documents',
      value: '6',
      subtext: 'Available',
      icon: LuFileText,
      iconColor: 'text-indigo-600',
      bgColor: 'bg-indigo-50',
    },
  ];

  return (
    <div className="w-full bg-slate-50 p-6 font-sans">
      {/* Header Section */}
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold text-slate-900 flex items-center gap-1">
            Equipment & Maintenance – Compliance Overview 
            <span className="font-normal text-slate-700">(Inspector View)</span>
          </h1>
          <p className="text-xs text-slate-500 mt-1">
            Evidence of equipment compliance, maintenance and service records.
          </p>
        </div>

        {/* Action Controls */}
        <div className="flex flex-wrap items-center gap-2">
          {/* Date Picker Button */}
          <button className="flex items-center gap-2 px-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-medium text-slate-700 hover:bg-slate-50 shadow-sm transition-colors">
            <LuCalendar className="text-slate-500 text-sm" />
            <span>18 Jul 2026 - 18 Jul 2026</span>
            <span className="text-[10px] text-slate-400 ml-1">▼</span>
          </button>

          {/* Filters Button */}
          <button className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-medium text-slate-700 hover:bg-slate-50 shadow-sm transition-colors">
            <LuSlidersHorizontal className="text-slate-500 text-sm" />
            <span>Filters</span>
          </button>

          {/* Export Button */}
          <button className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-medium text-slate-700 hover:bg-slate-50 shadow-sm transition-colors">
            <LuDownload className="text-slate-500 text-sm" />
            <span>Export</span>
          </button>
        </div>
      </div>

      {/* Grid KPI Cards Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {stats.map((stat) => {
          const IconComponent = stat.icon;
          return (
            <div 
              key={stat.id} 
              className="flex items-center gap-3 bg-white border border-slate-100 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Icon Container */}
              <div className={`p-2.5 rounded-xl ${stat.bgColor} flex-shrink-0`}>
                <IconComponent className={`text-xl ${stat.iconColor}`} />
              </div>

              {/* Data Content */}
              <div className="min-w-0">
                <p className="text-[11px] font-semibold text-slate-500 truncate leading-none mb-1">
                  {stat.title}
                </p>
                <p className="text-lg font-bold text-slate-900 leading-tight truncate">
                  {stat.value}
                </p>
                <p className="text-[10px] text-slate-400 truncate mt-0.5">
                  {stat.subtext}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
